/**
 * @generated SignedSource<<1a8bb2aaf571cb37d66d7fb92afa454d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateEmailLayoutTextContentInput = {
  id: string;
  textContent: string;
};
export type EmailLayoutDetailsViewUpdateTextMutation$variables = {
  input: UpdateEmailLayoutTextContentInput;
};
export type EmailLayoutDetailsViewUpdateTextMutation$data = {
  readonly updateEmailLayoutTextContent: {
    readonly id: string;
    readonly textContent: string;
    readonly updatedAt: any;
  };
};
export type EmailLayoutDetailsViewUpdateTextMutation = {
  response: EmailLayoutDetailsViewUpdateTextMutation$data;
  variables: EmailLayoutDetailsViewUpdateTextMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailLayout",
    "kind": "LinkedField",
    "name": "updateEmailLayoutTextContent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "textContent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailLayoutDetailsViewUpdateTextMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailLayoutDetailsViewUpdateTextMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4b3f496eca138cfced2dc2cbf5b8ebd9",
    "id": null,
    "metadata": {},
    "name": "EmailLayoutDetailsViewUpdateTextMutation",
    "operationKind": "mutation",
    "text": "mutation EmailLayoutDetailsViewUpdateTextMutation(\n  $input: UpdateEmailLayoutTextContentInput!\n) {\n  updateEmailLayoutTextContent(input: $input) {\n    id\n    textContent\n    updatedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "d9677720e5b2fd5e102d73e269ccb45b";

export default node;
